export default __webpack_public_path__ + "static/media/logo-en.709812cf.svg";